(function onPageLoad () {
	if (!window.SwymCallbacks) {
		window.SwymCallbacks = [];
	}
	window.SwymCallbacks.push(initSwymUI);
})();

let swat;
let settings;
let sectionId;
let elements;

function initSwymUI(swatInstance) {
	swat = swatInstance;

	const wishlistElement = document.querySelector('.swymcs-custom-wishlist');

	settings = JSON.parse(wishlistElement.dataset.settings);
	sectionId = wishlistElement.dataset.sectionid;

	elements = {
		loader: wishlistElement.querySelector('#swymcs-wishlist-loader'),
		container: wishlistElement.querySelector('#swymcs-wishlist-container'),
		listOptions: wishlistElement.querySelector('#swymcs-wishlist-list-options-container'),
		itemsContainer: wishlistElement.querySelector('#swymcs-wishlist-items-container'),
		emptyContainer: wishlistElement.querySelector('#swymcs-empty-wishlist-container'),
	};

	fetchWishlist();
}
function fetchWishlist() {
	showLoader();
	swat.fetchLists({
		callbackFn: (lists) => {
			lists = lists.reverse(); //Display lists in order of most recent creation
			swat.swymCustomWishlistLists = lists;

			const currentListId = swat.swymCustomWishlistSelectedListId || lists[0]?.lid;
			swat.swymCustomWishlistSelectedListId = currentListId;

			const selectedList = lists.find(({ lid }) => lid === currentListId) || lists[0];

			if (swat.isCollectionsEnabled()) //Render Dropdown with ListNames
				renderMultipleListOptions(lists);

			if(selectedList){
				renderList(selectedList.listcontents); //Render the list items
			}else{
				updateUIState([]);
			}

		},
		errorFn: (error) => console.error('Error while fetching all Lists', error),
	});
}
async function renderList(list) {
	elements.itemsContainer.innerHTML = '';
	if (list.length > 0) {
		const wishlistedProducts = await fetchProductData(list);
		wishlistedProducts.forEach(renderWishlistItem);
	}
	updateUIState(list);
}

async function fetchProductData(wishlist) {
	//Fetch Platform Product Data
	const productDataPromises = wishlist.map(async (listItem) => {
		const response = await fetch(`${listItem.du.split('?')[0]}.js`);
		listItem.productData = await response.json();
		return listItem;
	});
	return await Promise.all(productDataPromises);
}

function renderMultipleListOptions(lists) {
	/*
	if (lists.length > 1) {
		const listOptionsHtml = lists.map(({ lid, lname, listcontents }) => `
	  <option class="swymcs-wishlist-list-option" value="${lid}" ${lid === swat.swymCustomWishlistSelectedListId ? 'selected' : ''}>
		${lname} (${listcontents.length} items)
	  </option>`).join('');
		elements.listOptions.innerHTML = `
	  <select class="swymcs-wishlist-list" id="swym-mutliple-list" onchange="onListChange(event)">
		${listOptionsHtml}
	  </select>
	`;
	}

	 */
}

function onListChange(event) {
	swat.swymCustomWishlistSelectedListId = event.target.value;
	const selectedList = swat.swymCustomWishlistLists.find(({ lid }) => lid === event.target.value);
	renderList(selectedList.listcontents);
}
function renderWishlistItem(item) {
	const wishlistItem = document.createElement('div');
	wishlistItem.classList.add('product-card');
	wishlistItem.classList.add('ajax-preloader');
	wishlistItem.dataset.epi = item.epi;
	wishlistItem.dataset.empi = item.empi;
	wishlistItem.dataset.du = item.du;
	wishlistItem.dataset.sectionid = sectionId;

	const productImage = item.productData?.featured_image || item.iu;
	const selectedVariant = item.productData.variants.find(variant => variant.id == item.epi);
	const isInCart = _swat.platform.isInDeviceCart(selectedVariant.id);

	wishlistItem.innerHTML = `
		<div class="product-card-top">
			<a href="${item.du}" class="product-card-image media-wrapper" aria-label="${item.dt}">
				<img src="${productImage}" alt="${item.dt}" />
			</a>
		</div>
		<button id="swymcs-remove-productBtn" aria-label="Delete" class="swymcs-wishlistplus-item-remove product-card-wishlist-remove"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="-5.0 -10.0 110.0 135.0"> <g> <path d="m76.801 28.898h-53.602c-0.5 0-1 0.19922-1.3008 0.60156-0.30078 0.39844-0.5 0.89844-0.5 1.3008l4 49.199c0 4.6016 3.8008 8.3984 8.3984 8.3984h32.199c4.6016 0 8.3984-3.6992 8.3984-8.3984l4-49.199c0-0.5-0.10156-1-0.5-1.3008-0.19531-0.39844-0.59375-0.60156-1.0938-0.60156zm-5.8008 50.902v0.10156c0 2.6992-2.1992 4.8984-4.8984 4.8984h-32.199c-2.6992 0-4.8984-2.1992-4.8984-4.8984v-0.10156l-3.8984-48.602h49.898zm0 0" fill="#c02827"/> <path d="m88 10.098h-21.801v-5.8008c0-2.6992-2.1992-4.8984-4.8984-4.8984h-22.398c-2.6992 0-4.8984 2.1992-4.8984 4.8984v5.8008h-21.801c-1.6992 0-3 1.3008-3 3s1.3008 3 3 3h75.801c1.6992 0 3-1.3008 3-3s-1.3008-3-3-3zm-30.602 0h-19.801v-5.8008c0-1.1992 1-2.1992 2.1992-2.1992h15.602c1.1992 0 2.1992 1 2.1992 2.1992zm0 0" fill="#c02827"/> <path d="m59.102 30.5c-1.6992 0-3 1.3008-3 3v35.301c0 1.6992 1.3008 3 3 3s3-1.3008 3-3v-35.301c0-1.6992-1.3008-3-3-3zm-18.398 0c-1.6992 0-3 1.3008-3 3v35.301c0 1.6992 1.3008 3 3 3s3-1.3008 3-3v-35.301c0-1.6992-1.3008-3-3-3zm0 0" fill="#c02827"/> </g> </svg></button>
		<div class="product-card-bottom">
			<div class="product-card-content-wrapper">
			<div class="product-card-star-ratting">
				<etrusted-widget data-etrusted-widget-id="wdg-9c7f40aa-df52-4ec8-b25c-6c4f607d372e" data-sku="${item.productData.variants[0].sku}"></etrusted-widget>
			</div>
				<a href="${item.du}" class="product-card-title">
					${item.dt}
				</a>
				<div class="product-card-price">
					<div class="product-card-price-regular">
						${_swat.currency}${item.pr}
					</div>
				</div>
			</div>
			<div class="product-card-form-wrapper">
				<a href="${item.du}" class="product-card-title">
					${item.dt}
				</a>
				<div class="product-card-price">
					<div class="product-card-price-regular">
						${_swat.currency}${item.pr}
					</div>
				</div>
				<div class="product-card-form">
					<div class="product-card-form-inner">
						<quantity-block class="quantity-block">
							<button type="button" class="quantity-block-button button-decrease">
								<span class="icon icon-small-arrow"></span>
							</button>
							<input type="number" class="quantity-block-input" name="quantity" value="1" min="1">
							<button type="button" class="quantity-block-button button-increase ">
								<span class="icon icon-small-arrow"></span>
							</button>
						</quantity-block>
						<button class="swymcs-wishlist-add-to-cart-button product-card-form-submit" data-action="add-to-cart" ${!selectedVariant?.available ? 'disabled' : ''}>
							<span class="icon icon-plus"></span>
							<span class="icon icon-checkmark"></span>
							<span class="icon icon-cart"></span>

						</button>
					</div>
				</div>
				<a href="${item.du}" class="product-card-link underline-link">
					${window.translations.view_product}
				</a>
			</div>
		</div>



      `;

	wishlistItem.querySelector('[data-action="add-to-cart"]')?.addEventListener('click', (event) => {
		event.preventDefault();
		let button = event.target;

		console.log(button.tagName)
		if(button.tagName != 'BUTTON'){
			button = event.target.closest('button')
		}
		let { empi, epi, du, qty } = item;

		let originalButtonState = button.innerHTML;

		console.log(qty)
		if(button.closest('.product-card-form-inner').querySelector('[name="quantity"]')){
			qty = button.closest('.product-card-form-inner').querySelector('[name="quantity"]').value;
		}
		console.log(qty)
		swat.replayAddToCart(
			{ empi: empi, du: du, qty: qty},epi,
			(success) => {

				const variant = JSON.parse(success).items[0];
				const productTitle = variant.title;
				let successMessage = `<strong>${productTitle}</strong> has been added to cart!`;
				swat.ui.showSuccessNotification({ message:successMessage });

				button.classList.add('added');
				setTimeout(function (){
					button.classList.remove('added');
				},4000)
			},
			(error) => {
				button.innerHTML = originalButtonState;
				// swat.ui.showErrorNotification({ message: error.description });
              wishlistAddToCartErrorPopup(error.description,button.closest('.product-card-form-wrapper').querySelector('.product-card-title').innerHTML)
			}
		);
	});

	wishlistItem.querySelector('#swymcs-remove-productBtn')?.addEventListener('click', (event) => {
		let product = {
			epi: item.epi,
			empi: item.empi,
			du: item.du
		}
		let productCard = event.target.closest('.product-card');
		productCard.classList.add('loading')
		// _swat.deleteFromList(_swat.swymCustomWishlistSelectedListId, product, ()=>{ fetchWishlist() }, (error) => console.error('Failed to remove from wishlist', error));
		_swat.deleteFromList(_swat.swymCustomWishlistSelectedListId, product, ()=>{

				productCard.remove();
				if(!document.querySelector('#swymcs-wishlist-items-container .product-card')){
					fetchWishlist()
				}
			}, (error) => console.error('Failed to remove from wishlist', error));
	});

	elements.itemsContainer.appendChild(wishlistItem);

	setTimeout(function (){
		productCardSize();
	},500)
}
function updateUIState(wishlist) {
	hideLoader();
	if (wishlist.length > 0) {
		elements.container.classList.remove('swymcs-hide-container');
		elements.emptyContainer.classList.add('swymcs-hide-container');
	} else {
		elements.emptyContainer.classList.remove('swymcs-hide-container');
		elements.container.classList.add('swymcs-hide-container');
	}
}

function showLoader() {
	elements.loader.classList.remove('swymcs-hide-container');
}

function hideLoader() {
	elements.loader.classList.add('swymcs-hide-container');
}
function wishlistAddToCartErrorPopup(text, title) {
  
  if(document.querySelector('#error-popup')){
      document.querySelector('#error-popup').querySelector('.section-title-small').innerHTML = title;
      document.querySelector('#error-popup').querySelector('.popup-text').innerHTML = text;
      Fancybox.show([
          {
              src: "#error-popup"
          }
      ]);
  }
        
}